import { Form, Input, Row } from "antd";
import { useTextFieldRules } from "../../hooks/useTextFieldRules";

type AdditionalInfoProps = {
  title: string;
  subTitle: string;
  fullNameFormName: string;
  titleFormName: string;
  disabled: boolean;
};

export const AdditionalInfo = ({
  title,
  subTitle,
  fullNameFormName,
  titleFormName,
  disabled,
}: AdditionalInfoProps) => {
  const { titleRules, fullNameRules } = useTextFieldRules();

  return (
    <Row className="d-block w-100">
      <p className="mt-0 mb-1 text w-500">{title}</p>
      <p className="mb-4 mt-0 text-md title">{subTitle}</p>
      <Form.Item
        label="Full Name"
        className="mb-4"
        name={fullNameFormName}
        rules={fullNameRules}
      >
        <Input disabled={disabled} />
      </Form.Item>
      <Form.Item
        label="Title"
        className="mb-4"
        name={titleFormName}
        rules={titleRules}
      >
        <Input placeholder="e.g. Customer Service" />
      </Form.Item>
    </Row>
  );
};
